// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { NotificationSubscriptionsPage } from '@/notification/components/notification-subscriptions-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/notifications/subscriptions')({
  component: NotificationSubscriptionsRoute,
});

function NotificationSubscriptionsRoute() {
  return <NotificationSubscriptionsPage />;
}
